import { Link } from "react-scroll";

const Hero = () => {
    return (
        <section id="home" className="hero">
            <div className="hero-content">
                <h1>Southern California Professional Structural Framing. Built to Last.</h1>
                <p style={{fontSize:'larger'}}>Reliable Framing for Homes and Commercial Projects</p>
                <Link to="contact" smooth={true} duration={500} offset={-70}>
                    <button className="cta-btn">Get in Touch</button>
                </Link>
            </div>
        </section>
    );
};

export default Hero;
